import _trimEnd from 'lodash/trimEnd';

module.exports = {
  path: ':id',
  indexRoute: {
    onEnter: (nextState, replace) => replace(`${_trimEnd(nextState.location.pathname, '/')}/information`),
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/information'),
        require('./routes/device'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/SimcardShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/routes/show/index.js